
import React, { useEffect, useState } from "react";
import AuthService from "../../../api/services/AuthService";
import { alertErrorMessage, alertSuccessMessage } from "../../../customComponent/CustomAlertMessage";
import { CSVLink } from "react-csv";
import LoaderHelper from "../../../customComponent/Loading/LoaderHelper";
import moment from "moment";
import DataTableBase from "../../../customComponent/DataTable";
import ReactPaginate from "react-paginate";
import { Link } from "react-router-dom";
import { ApiConfig } from "../../../api/apiConfig/ApiConfig";


const SIPFundsPendingDeposit = () => {
    const [fundsDeposit, setFundsDeposit] = useState([]);
    const [allData, setAllData] = useState([]);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [confirmAction, setConfirmAction] = useState(null);
    //     const [currentPage, setCurrentPage] = useState(1);
    //   const [itemsPerPage, setItemsPerPage] = useState(10);
    //   const [totalData,setTotalData] = useState()


    //   const handlePageChange = ({ selected }) => {
    //       setCurrentPage(selected + 1);
    //   };


    //   const pageCount = totalData/itemsPerPage

    //   const skip = (currentPage - 1) * itemsPerPage;

    function statusFormatter(row) {
        return <>
            <button className={`btn btn-success btn-sm   me-2 my-1`} onClick={() => { 
                setConfirmAction({ 
                    type: 'single', 
                    id: row?._id, 
                    status: "COMPLETED",
                    message: "Are you sure you want to approve this deposit?",
                    data: row
                }); 
                setShowConfirmModal(true); 
            }}>Approve
            </button>
            <button className={`btn btn-danger btn-sm   me-2 my-1`} onClick={() => { 
                setConfirmAction({ 
                    type: 'single', 
                    id: row?._id, 
                    status: "REJECTED",
                    message: "Are you sure you want to reject this deposit?",
                    data: row
                }); 
                setShowConfirmModal(true); 
            }}>Reject
            </button>
        </>
    };

    const userIdFollow = (row) => {
        return (
          row.user
        );
      };
    
    const [selectedIds, setSelectedIds] = useState([]);
    const handleSelect = (row) => {
        return <>
            <input type="checkbox" value={row?._id} onChange={handleCheckboxInput} checked={selectedIds?.includes(row?._id)} style={{ height: "100px", width: "30px" }} />
        </>
    };

    const handleCheckboxInput = (e) => {
        const value = e.target.value;
        if (selectedIds?.includes(value)) {
            const filteredItem = selectedIds?.filter((item) => item !== value)
            setSelectedIds(filteredItem)
        } else {
            setSelectedIds([...selectedIds, value])
        }

    }

    const selectAll = (e) => {
        if (e.target.checked) {
            const allIds = allData?.map((item) => item?._id);
            setSelectedIds(allIds)
        } else {
            setSelectedIds([])
        }

    };


    const handleImageShow = (row) => {
        return (
            row?.transaction_slip?   <a href={ApiConfig?.appUrl + row?.transaction_slip} target="_blank" rel="noreferrer">  <img style={{ width: "40%", height: "auto" }} src={ApiConfig?.appUrl + row?.deposit_slip} alt="Receipt" className="table-img cursor_pointer" /></a>:"---"
        );
    };



    const columns = [
        { name: "Select", wrap: true, selector: handleSelect },
        { name: "Sr No.", wrap: true, selector: (row, index) => allData.indexOf(row) + 1, },
        { name: "Date", selector: row => moment(row?.transaction_date).format("MMM Do YYYY, h:mm:ss a"), wrap: true },
        { name: "User ID", wrap: true, selector: userIdFollow },
        { name: "Email", wrap: true, selector: row => row.emailId, },
        { name: "Currency", wrap: true, selector: row => row.currency, },
        { name: "Amount", sortable: true, wrap: true, selector: row => `${row.installment_amount} (${row.installment_number}/${row.no_of_installments})`, },
        { name: "Transaction No.", sortable: true, wrap: true, selector: row => row?.transaction_number || "---", },
        { name: "Receipt", sortable: true, wrap: true, selector: handleImageShow, },
        { name: "Status", wrap: true, selector: statusFormatter, },
    ];

    useEffect(() => {
        handleFundDeposit()
    }, []);

    const handleFundDeposit = async () => {
        LoaderHelper.loaderStatus(true);
        await AuthService.SIPPendingRequests().then(async result => {
            LoaderHelper.loaderStatus(false);
            if (result.success) {
                try {
                    setFundsDeposit(result.data);
                    setAllData(result.data);
                } catch (error) {
                    alertErrorMessage(error);
                }
            } else {
                LoaderHelper.loaderStatus(false);
            }
        });
    };

    const updateDepositRequest = async (id, status) => {
        LoaderHelper.loaderStatus(true);
        await AuthService.rejectInstallment(id, status).then(async result => {
            LoaderHelper.loaderStatus(false);
            if (result.success) {
                try {
                    alertSuccessMessage(result?.message)
                    handleFundDeposit()
                } catch (error) {
                    alertErrorMessage(error);
                }
            } else {
                alertErrorMessage(result?.message)
                LoaderHelper.loaderStatus(false);
            }
        });
    };

    function handleSearch(e) {
        const keysToSearch = ["chain", "currency", "emailId", "firstName", "from_address", "to_address", "transaction_hash", "amount", "mobileNumber", "user_id"];
        const searchTerm = e.target.value?.toLowerCase();
        const matchingObjects = allData.filter(obj => { return keysToSearch.some(key => obj[key]?.toString()?.toLowerCase()?.includes(searchTerm)) });
        setFundsDeposit(matchingObjects);
    };

    const approveSelectedRequest = async (status) => {
        if (selectedIds?.length === 0) {
            alertErrorMessage("Please select user")
            return
        }
        setConfirmAction({ 
            type: 'multiple', 
            status: status,
            message: `Are you sure you want to ${status === "SUCCESS" ? "approve" : "reject"} the selected deposits?`
        }); 
        setShowConfirmModal(true);
    }

    const handleConfirmAction = async () => {
        setShowConfirmModal(false);
        
        if (confirmAction.type === 'single') {
            await updateDepositRequest(confirmAction.id, confirmAction.status);
        } else if (confirmAction.type === 'multiple') {
            for await (const id of selectedIds) {
                await updateDepositRequest(id, confirmAction.status)
            }
            alertSuccessMessage("Selected request updated")
            setSelectedIds([])
            handleFundDeposit()
        }
        
        setConfirmAction(null);
    }

    const handleCancelAction = () => {
        setShowConfirmModal(false);
        setConfirmAction(null);
    }


    return (
        <div id="layoutSidenav_content">
            <main>
                <header className="page-header page-header-dark bg-gradient-primary-to-secondary pb-10">
                    <div className="container-xl px-4">
                        <div className="page-header-content pt-4">
                            <div className="row align-items-center justify-content-between">
                                <div className="col-auto mt-4">
                                    <h1 className="page-header-title">
                                        <div className="page-header-icon"><i className="fa fa-dollar-sign"></i></div>
                                        Pending Deposit
                                    </h1>
                                </div>
                            </div>
                        </div>
                    </div>
                </header>

                <div className="container-xl px-4 mt-n10">
                    <div className="card mb-4">
                        <div className="card-header">
                            Pending Deposit
                            <div>
                                <label for="selectall" className="mx-2 cursor-pointer" >Select all</label>
                                <input id="selectall" type="checkbox" onChange={selectAll} />
                            </div>
                            <div className="col-5">
                                <input className="form-control form-control-solid" id="inputLastName" type="text" placeholder="Search here..." name="search" onChange={handleSearch} />
                            </div>
                            {fundsDeposit.length === 0 ? "" :
                                <div className="dropdown">
                                    <button className="btn btn-dark btn-sm dropdown-toggle" id="dropdownFadeInUp" type="button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        Export{" "}
                                    </button>
                                    <div className="dropdown-menu animated--fade-in-up" aria-labelledby="dropdownFadeInUp">
                                        <CSVLink data={fundsDeposit} className="dropdown-item">Export as CSV</CSVLink>
                                    </div>
                                </div>}

                            <div>
                                <button
                                    className="btn mx-2 btn-success "
                                    type="button" onClick={() => approveSelectedRequest("SUCCESS")}
                                >
                                    Approve
                                </button>
                                <button
                                    className="btn mx-2 btn-danger "
                                    type="button" onClick={() => approveSelectedRequest("REJECTED")}
                                >
                                    Reject
                                </button>
                            </div>
                        </div>
                        <div className="table-responsive mt-4" width="100%">
                            <DataTableBase columns={columns} data={fundsDeposit} />
                        </div>
                        {/* {totalData > 5 ? <ReactPaginate
                            pageCount={pageCount}
                            onPageChange={handlePageChange}
                            containerClassName={'customPagination'}
                            activeClassName={'active'}
                        /> : ""} */}
                    </div>
                </div>
            </main>

            {/* Confirmation Modal */}
            {showConfirmModal && (
                <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }} tabIndex="-1">
                    <div className="modal-dialog modal-dialog-centered modal-lg">
                        <div className="modal-content p-2">
                            <div className="modal-header">
                                <h5 className="modal-title">Confirm Action</h5>
                                <button type="button" className="btn-close" onClick={handleCancelAction}></button>
                            </div>
                            <div className="modal-body">
                                {confirmAction?.type === 'single' && confirmAction?.data && (
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="row mb-2">
                                                <div className="col-md-6">
                                                    <strong>User ID:</strong> {confirmAction.data.user || 'N/A'}
                                                </div>
                                                <div className="col-md-6">
                                                    <strong>Email:</strong> {confirmAction.data.emailId || 'N/A'}
                                                </div>
                                            </div>
                                            <div className="row mb-2">
                                                <div className="col-md-6">
                                                    <strong>Currency:</strong> {confirmAction.data.currency || 'N/A'}
                                                </div>
                                                <div className="col-md-6">
                                                    <strong>Amount:</strong> {confirmAction.data.installment_amount} ({confirmAction.data.installment_number}/{confirmAction.data.no_of_installments})
                                                </div>
                                            </div>
                                            <div className="row mb-2">
                                                <div className="col-md-6">
                                                    <strong>Transaction No:</strong> {confirmAction.data.transaction_number || '---'}
                                                </div>
                                                <div className="col-md-6">
                                                    <strong>Date:</strong> {moment(confirmAction.data.transaction_date).format("MMM Do YYYY, h:mm:ss a")}
                                                </div>
                                            </div>
                                            {confirmAction.data.transaction_slip && (
                                                <div className="row mt-3">
                                                    <div className="col-12">
                                                        <strong>Transaction Slip:</strong>
                                                        <div className="mt-2">
                                                            <a href={ApiConfig?.appUrl + confirmAction.data.transaction_slip} target="_blank" rel="noreferrer">
                                                                <img 
                                                                    style={{ maxWidth: '100%', height: 'auto', maxHeight: '300px' }} 
                                                                    src={ApiConfig?.appUrl + confirmAction.data.transaction_slip} 
                                                                    alt="Receipt" 
                                                                    className="img-thumbnail cursor_pointer" 
                                                                />
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                )}
                                
                                {confirmAction?.type === 'multiple' && (
                                    <div className="alert alert-info">
                                        <strong>{selectedIds.length}</strong> deposit(s) selected
                                    </div>
                                )}
                            </div>
                            <div className="modal-footer d-flex justify-content-between align-items-center">
                                <p className="mb-3"><strong>{confirmAction?.message}</strong></p>
                                <div >
                                <button type="button" className="me-4 btn btn-secondary" onClick={handleCancelAction}>
                                    No
                                </button>
                                <button type="button" className="btn btn-primary" onClick={handleConfirmAction}>
                                    Yes
                                </button></div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default SIPFundsPendingDeposit;